import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CollectionMockup } from './CollectionMockup';
import { cta, offerStack, price, productName } from '../data/content';
export function OfferStack() {
  return <section id="oferta" className="scroll-mt-4 bg-ink" data-id="element-123" data-mp="2puddorlxlwwy">
      <div className="mx-auto w-full max-w-content px-5 py-12 sm:px-6 lg:py-20" data-id="element-124" data-mp="2kvttowqwev78">
        <h2 className="text-center font-display text-[clamp(1.6rem,7vw,1.9rem)] font-semibold uppercase leading-tight tracking-tight text-ivory sm:text-5xl" data-id="element-125" data-mp="1x5zhmheelao1">
          {offerStack.title}
        </h2>

        <div className="mx-auto mt-7 grid w-full max-w-md grid-cols-1 items-center gap-6 lg:max-w-5xl lg:grid-cols-2 lg:gap-10" data-id="element-126" data-mp="26wu5fq7asibl">
          <div className="min-w-0" data-id="element-127" data-mp="224sklfw2dj9y">
            <CollectionMockup variant="photo" data-id="element-128" data-mp="223r7z6zegoq4" />
          </div>

          <div className="min-w-0 rounded-3xl bg-ivory px-5 py-7 text-center text-ink sm:p-9" data-id="element-129" data-mp="1eeor41clazwo">
            <p className="font-display text-[clamp(1.6rem,7.5vw,2rem)] font-semibold leading-none tracking-tight sm:text-4xl" data-id="element-130" data-mp="19g54rzu33m3s">{productName}</p>

            <ul className="mx-auto mt-6 max-w-sm space-y-2.5 text-left" data-id="element-131" data-mp="14n8yx2esuvpx">
              {offerStack.items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-132" data-mp="1eed5bdqet895">
                  <span aria-hidden="true" className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-sage-deep" data-id="element-133" data-mp="1eh939229bwxl">
                    <CheckIcon className="h-3 w-3 text-ivory" strokeWidth={3.5} data-id="element-134" data-mp="lr0uu1xiwqw7" />
                  </span>
                  <span className="font-sans text-[0.98rem] font-medium leading-snug" data-id="element-135" data-mp="qqdekdt3lhuk">{item}</span>
                </li>)}
            </ul>

            <div className="mt-7 border-t border-stone pt-6" data-id="element-136" data-mp="vqrndy2iwvtn">
              <p className="font-display text-[clamp(3rem,16vw,4.5rem)] font-semibold leading-none tracking-tight sm:text-[5.5rem]" data-id="element-137" data-mp="zqs5bsotzp5g">
                {price}
              </p>
              <p className="mt-2 font-sans text-sm font-semibold text-ink/70" data-id="element-138" data-mp="2b4e0buhdgkyw">{offerStack.terms}</p>
            </div>

            <div className="mx-auto mt-6 max-w-md" data-id="element-139" data-mp="bz2tk59telq7">
              <CtaButton tone="ink" data-id="element-140" data-mp="71b2tekwp5nl">{cta.access}</CtaButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}